import { upcMapper } from '@common-vue/media-card-large/src/composables/useUpc';

/**
 *
 * @param {Product} product
 * @param {LatchKeyProduct} latchkeyProduct
 * @returns {import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.UpcData}
 */
export default function UpcParser(product, latchkeyProduct) {
  /**
   * @type {{ upcMap: import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.UpcMap}}
   */
  const { upcMap } = latchkeyProduct?.traits?.traitsMaps || {};

  const upcs = Object
    .fromEntries(
      Object.entries(product.relationships.upcs || {})
        .map(([key, value]) => [key, upcMapper(value)]),
    );

  return {
    upcMap,
    upcs,
  };
}
